// @flow

import * as Immutable from 'immutable';
import invariant      from 'invariant';

// -----------------------------------------------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------------------------------------------

export type ModuleStatePath = string;

export type PublicBranch = Array<string>;

export type PublicBranches = Array<PublicBranch>;

export type UserConfig = {
  moduleStatePath: ModuleStatePath,
  publicBranches: PublicBranches,
  ignoreActions?: Array<string>,
};

type InternalConfig = {
  baseState?: Immutable.Map<string, *>,
};

export type Config = UserConfig
  // Require `ignoreActions` to be present
  & { ignoreActions: $PropertyType<UserConfig, 'ignoreActions'> }
  & InternalConfig;


// -----------------------------------------------------------------------------------------------------------------
// Config
// -----------------------------------------------------------------------------------------------------------------

let config: Config;

const defaultConfig = {
  ignoreActions: [],
};


// -----------------------------------------------------------------------------------------------------------------
// Set config
// -----------------------------------------------------------------------------------------------------------------

/**
 * @param {Config} newConfig
 */
export const configure = (newConfig: $Shape<Config>) => {

  invariant(newConfig, 'Missing config');

  config = Object.assign({}, config || defaultConfig, newConfig);

};


// -----------------------------------------------------------------------------------------------------------------
// Get config
// -----------------------------------------------------------------------------------------------------------------

/**
 * Returns the config.
 *
 * @throws if the config has not been set.
 *
 * @return {Config}
 */
export const getConfig = (): $ReadOnly<Config> => {

  invariant(config, 'config is not set.  Did you forget to call configure()?');

  // Return a clone, so we can't modify the original
  return Object.assign({}, config);

};


// WEBPACK FOOTER //
// ./src/modules/personalContent/config.js